module.exports = __webpack_public_path__ + "static/media/card_bg_4.7cd92fc0.png";